import { Accordion } from "react-bootstrap";
import TreeAndBuilding from "./CommonFields/TreeAndBuilding";

function Building({ jobList }) {
  return (
    <Accordion className="footage-accordian">
      {jobList &&
        jobList.buildings &&
        jobList.buildings.length > 0 &&
        jobList.buildings.map((value, index) => {
          return (
            <TreeAndBuilding
              FootageType={"Buildings"}
              value={value}
              index={index}
            />
          );
        })}
    </Accordion>
  );
}

export default Building;
